export const PRODUCT_CAPTURE_CONST = 'productCapture';
